// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-trigger.visibility-visible, .menu-trigger:hover {
  background: #F8F8F8;
  border-radius: 50%;
}

.menu-popper {
  background: #FDFDFD !important;
}
.menu-popper .tippy-content {
  padding: 0 !important;
}
.menu-popper .tippy-arrow::before {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/menu/style.scss"],"names":[],"mappings":"AACE;EAEE,mBAAA;EACA,kBAAA;AADJ;;AAKA;EACE,8BAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;AAKE;EACE,wBAAA;AAHJ","sourcesContent":[".menu-trigger {\n  &.visibility-visible,\n  &:hover {\n    background: theme('colors.grey-5');\n    border-radius: 50%;\n  }\n}\n\n.menu-popper {\n  background: theme('colors.white') !important;\n\n  .tippy-content {\n    padding: 0 !important;\n  }\n\n  .tippy-arrow::before {\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
